const menu = {
    ru: {
        menu_item_1: "Услуги и портфолио",
        menu_item_2: "О нас",
        menu_item_3: "Команда",
        menu_item_4: "Оставить заявку",
        menu_item_5: "Контакты"
    },
    eng: {
        menu_item_1: "Services & Cases",
        menu_item_2: "About us",
        menu_item_3: "Our team",
        menu_item_4: "Get a proposal",
        menu_item_5: "Contact "
    },
    az: {
        menu_item_1: "Xidmətlər və nümunələr",
        menu_item_2: "Haqqımızda",
        menu_item_3: "Komanda",
        menu_item_4: "Müraciət et",
        menu_item_5: "Əlaqə",
    }
}

export default menu



